const format = {
    label: 'Buffer', 
    value: 'buffer'
};

export { format };


// WEBPACK FOOTER //
// /home/travis/build/cedalo/streamsheets-pro-features/packages/webui-extensions/src/formats/buffer/index.js